/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).on("change", ".yotpo-selling-plan-radio-label", function () {
  var get_text = $(this).next(".yotpo-radio-label-text").text();
  console.log("is change-" + get_text);
  if (get_text == "Subscribe to Save" || get_text == "Subscribe to save") {
    $(".recurring_text").show();
    $(".sub_sav_option_wrapper .delivery_option_wrapper").show();
    $(".buy_more_save_wrapper").hide();
    var get_selected_default_variant = $(".hidden_value_set").attr(
      "data-selectedvariant_id"
    );
    $(
      '.flex_inner_wraper input[type="hidden"], .flex_wrapper input[type="hidden"]'
    ).val();
    var product_id = $(".hidden_value_set").attr("data-proID");
    $(
      '.flex_inner_wraper input[type="hidden"], .flex_wrapper input[type="hidden"]'
    ).attr("data-productid", product_id);
  } else {
    // console.log("this is one time clicked");
    $(".recurring_text").hide();
    $(".sub_sav_option_wrapper .delivery_option_wrapper").hide();
    $(".buy_more_save_wrapper").show();
    
    if ($('.buy_more_bundle').length) {
      var variant_id = $(".buy_more_bundle .bundle_group input:checked").attr("data-pro-varid");
    } else {
      var variant_id = $(".hidden_value_set").attr("data-selectedvariant_id");
    }
    // console.log('this is varint id',variant_id);

    $(
      '.flex_inner_wraper input[type="hidden"], .flex_wrapper input[type="hidden"]'
    ).val(variant_id);
    var product_id = $(".buy_more_bundle .bundle_group input:checked").attr(
      "data-productid"
    );
    $(
      '.flex_inner_wraper input[type="hidden"], .flex_wrapper input[type="hidden"]'
    ).attr("data-productid", product_id);
  }
});

$(document).on("change", ".buy_more_bundle .bundle_group input", function () {
  var variant_id = $(this).attr("data-pro-varid");
  console.log('buy more and save is clicked - Variant id is',variant_id)
  $(
    '.flex_inner_wraper input[type="hidden"], .flex_wrapper input[type="hidden"]'
  ).val(variant_id);
  var variant_price = $(this).attr("data-price");

  var variantPriceWithNoMoney = $(this).attr("data-price-without-money");
  $(
    ".ProductForm__QuantitySelector .QuantitySelector_numbers .plus_quantity"
  ).attr("data-variant-price", variantPriceWithNoMoney);
  $(
    ".ProductForm__QuantitySelector .QuantitySelector_numbers .minus_quantity"
  ).attr("data-variant-price", variantPriceWithNoMoney);
  var inputValue = getInputValue();
  var totalPrice = inputValue * variantPriceWithNoMoney;
  var formatMoney = Shopify.formatMoney(totalPrice);
  updatePrice(formatMoney);
  // $(".premium_product.ProductForm__AddToCart .wrap_text .update_price").text(
  //   formatMoney
  // );
  //  console.log('this is proper money',formatMoney)

  //  $('.ProductForm__AddToCart .wrap_text .update_price').text(variant_price);
  var get_available = $(this).attr("data-variant-available");
  let svg = `<svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM25.7071 8.7071C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928931C18.9526 0.538406 18.3195 0.538406 17.9289 0.928931C17.5384 1.31946 17.5384 1.95262 17.9289 2.34314L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.7071ZM1 9L25 9L25 7L1 7L1 9Z" fill="white"/>
</svg>
`;
  if (get_available == "true") {
    $(".ProductForm__AddToCart, .stay_ai_btn").removeAttr("disabled");
    $(".ProductForm__AddToCart, .stay_ai_btn").removeClass("Button--secondary");
    $(".ProductForm__AddToCart, .stay_ai_btn").addClass("Button--primary");
    $(".ProductForm__AddToCart, .stay_ai_btn").html(
      '<span class="wrap_text"><span>Add to cart</span> <div class="button-with-arrow"><span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +
        formatMoney +
        '</span>' + svg + '</div></span>'
    );

    let productPrice = $('.sub_sav_optioninner input[value="one time"]').attr('data-price');
    $(".ProductMeta__PriceList").html('<span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +productPrice +"</span>");
  } else {
    $(".ProductForm__AddToCart, .stay_ai_btn").prop("disabled", true);
    $(".ProductForm__AddToCart, .stay_ai_btn").removeClass("Button--primary");
    $(".ProductForm__AddToCart, .stay_ai_btn").addClass("Button--secondary");
    $(".ProductForm__AddToCart, .stay_ai_btn").text("Sold Out");
  }
});



let subscribeOnEvent = function(){
  // $(".yotpo-selling-plans .yotpo-radio-subscription-container .yotpo-radio-button-text-wrapper .yotpo-radio-buttons label.yotpo-radio-label input").attr("checked", true).trigger("click");
}

function onSubscribeEvent() {
  //Selling plans - frequencies 
  $(".variant-list").each(function () {
    // $(".yotpo-selling-plans .yotpo-radio-subscription-container .yotpo-radio-button-text-wrapper .yotpo-radio-buttons label.yotpo-radio-label input").attr("checked", true).trigger("click");

    let selVar = $(".SizeSwatch__Radio:checked").val();
    // console.log('Selected frequency is', selVar)
    if (selVar) {
      var clickedVar = selVar.replace(" ", "_");
      let x = `.${clickedVar}`;
      var variantPrice = Number($(x).find("input").attr("data-variant-price"));
    }
    var inputValue = getInputValue();
    // console.log('this is onSubscribeEvent function', inputValue);
    var totalPrice = inputValue * variantPrice;
    var formatMoney = Shopify.formatMoney(totalPrice);

    $(".ProductForm__AddToCart .wrap_text .update_price, .stay_ai_btn .wrap_text .update_price").text(formatMoney);
  });
}

$(document).on(
  "change",
  ".sub_sav_optioninner .option_group input",
  function () {
    var get_val = $(this).val();
    var get_available = $(this).attr("data-variant-available");
    if (get_val == "Subscribe & Save") {
      console.log("subsribe frequency clicked=>", get_val);

      let oneTimeInput;

      let activeID = $('.our-selling-product__tab-content .Product.tab-active').attr('id');
      if (activeID) {
        $(`#${activeID} .sub_sav_option_wrapper .main-price-with-text`).show();
      } else {
        $('.sub_sav_option_wrapper .main-price-with-text').show();
      }

        // Iterate over each input in the .SizeSwatchList-One-time section
        $('.SizeSwatchList-One-time .HorizontalList__Item input').each(function() {
          if ($(this).is(':checked')) {
            oneTimeInput = $(this).attr('value');
          }
        });

        // If oneTimeInput is set (i.e., a value was found), proceed to check the .SizeSwatchList-subscribe section
        if (oneTimeInput) {
          $('.SizeSwatchList-subscribe .HorizontalList__Item input').each(function() {
            // Check if the value matches the oneTimeInput
            if ($(this).attr('value') === oneTimeInput) {
              // Find the label associated with this input and click it
              $(this).closest('.HorizontalList__Item').find('label').click();
            }
          });
        }

      // hide-show variant
      $(".SizeSwatchList-One-time").hide();
      $(".SizeSwatchList-subscribe").show();
      //end
      // control selected variant on change mode of plan
      $(".SizeSwatchList-One-time input").each(function () {
        if ($(this).is(":checked")) {
          var value = $(this).val();
          // console.log(value);
          $(".SizeSwatchList-subscribe label").each(function () {
            var dataLabelValue = $(this).data("label");
            if (dataLabelValue === value) {
              // Click on the label
              //$(this).click();
            }
          });
        }
      });
      // end

      // console.log("this is clicked subsribe");
      $(".sub_sav_option_wrapper .delivery_option_wrapper").show();
      $(".buy_more_save_wrapper").hide();

      // function for control monthly option selector as per variants
      onSubscribeEvent(); //old yotpo
      subscribeOnEvent();
      //end
      getSubscriptionPrice();

      if (get_available == "false") {
        ".ProductForm__AddToCart".prop("disabled", true);
        $(".ProductForm__AddToCart").removeClass("Button--primary");
        $(".ProductForm__AddToCart").addClass("Button--secondary");
        $(".ProductForm__AddToCart").text("Sold Out");
      } else {
        $(".ProductForm__AddToCart").removeAttr("disabled");
        $(".ProductForm__AddToCart").removeClass("Button--secondary");
        $(".ProductForm__AddToCart").addClass("Button--primary");
      }

      $(".delivery_option_inner .option_group input:checked").each(function (
        i,
        x
      ) {
        let selVariant = $(".SizeSwatchList input:checked").val();
        if (selVariant) {
          let clickedVar = selVariant.replace(" ", "_");
          if ($(x).parents('.variant-list').hasClass(clickedVar)) {
            var variantPrice = Number($(x).attr("data-variant-price"));

            //  var price_val = $(x).attr('data-price');
            var inputValue = getInputValue();
            // console.log('this is another inputValue', inputValue);
            var totalPrice = inputValue * variantPrice;
            var formatMoney = Shopify.formatMoney(totalPrice);
            let svg = `<svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM25.7071 8.7071C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928931C18.9526 0.538406 18.3195 0.538406 17.9289 0.928931C17.5384 1.31946 17.5384 1.95262 17.9289 2.34314L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.7071ZM1 9L25 9L25 7L1 7L1 9Z" fill="white"/>
</svg>
`;

            $(".ProductForm__AddToCart .wrap_text .update_price, .stay_ai_btn .wrap_text .update_price").text(formatMoney);

            $(".ProductForm__AddToCart, .stay_ai_btn").html(
      '<span class="wrap_text"><span>Add to cart</span> <div class="button-with-arrow"><span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +
        formatMoney +
        '</span>' + svg + '</div></span>'
    );
            let productPrice = $('.sub_sav_optioninner input[value="one time"]').attr('data-price');
            $(".ProductMeta__PriceList").html('<span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +productPrice +"</span>");

            $(
              ".ProductForm__QuantitySelector .QuantitySelector_numbers .plus_quantity"
            ).attr("data-variant-price", variantPrice);
            $(
              ".ProductForm__QuantitySelector .QuantitySelector_numbers .minus_quantity"
            ).attr("data-variant-price", variantPrice);
        }

        const sellingPlanId = x.dataset.valId
        const sellingPlanInput = document.querySelector('.product__selling-plan-input')
        if (sellingPlanInput && sellingPlanId) {
          sellingPlanInput.value = sellingPlanId;
          let activeID =  $('.our-selling-product__tab-content .Product.tab-active').attr('id');
          
          if (activeID) {
            $(`#${activeID} .stay_ai_btn`).attr('data-selling-id', sellingPlanId);
          } else {
            $('.stay_ai_btn').attr('data-selling-id', sellingPlanId);
          }
        }
      }
      });
      
      // $(".yotpo-selling-plans .yotpo-radio-container").each(function (ie, ex) {
      //   var get_lable_text = $(ex)
      //     .find(
      //       ".yotpo-radio-button-text-wrapper .yotpo-radio-buttons label.yotpo-radio-label .yotpo-radio-label-text"
      //     )
      //     .text();

      //   if (
      //     get_lable_text == "Subscribe to Save" ||
      //     get_lable_text == "Subscribe to save"
      //   ) {
      //     $(".yotpo-selling-plans .yotpo-radio-subscription-container .yotpo-radio-button-text-wrapper .yotpo-radio-buttons label.yotpo-radio-label input").attr("checked", true).trigger("click");
      //   }
      // });
    } else {
      // hide-show varant group
      $(".SizeSwatchList-subscribe").hide();
      $(".SizeSwatchList-One-time").show();
      //end
      //control selected variant based on mode
      $(".SizeSwatchList-subscribe input").each(function () {
        if ($(this).is(":checked")) {
          var value = $(this).val();
          // console.log(value);
          $(".SizeSwatchList-One-time label").each(function () {
            var dataLabelValue = $(this).data("label");
            if (dataLabelValue === value) {
              // Click on the label
              $(this).click();
            }
          });
        }
      });

      // Remove sellingplan
      const sellingPlanInput = document.querySelector('.product__selling-plan-input')
      if (sellingPlanInput) {
        sellingPlanInput.value = '';
        let activeID =  $('.our-selling-product__tab-content .Product.tab-active').attr('id');

        if (activeID) {
          $(`#${activeID} .stay_ai_btn`).attr('data-selling-id', '');
        } else {
          $('.stay_ai_btn').attr('data-selling-id', '');
        }
      }
      //end

      $(".buy_more_save_inner .buy_more_bundle .bundle_group input").each(
        function () {
          if ($(this).is(":checked")) {
            let quantity = getInputValue();
            let variantPrice = Number($(this).attr("data-price-without-money"));
            let totalPrice = quantity * variantPrice;
            let formatMoney = Shopify.formatMoney(totalPrice);
            $(
              ".ProductForm__QuantitySelector .QuantitySelector_numbers .plus_quantity"
            ).attr("data-variant-price", variantPrice);
            $(
              ".ProductForm__QuantitySelector .QuantitySelector_numbers .minus_quantity"
            ).attr("data-variant-price", variantPrice);
            updatePrice(formatMoney);
            // $(
            //   ".premium_product.ProductForm__AddToCart .wrap_text .update_price"
            // ).text(formatMoney);
          }
        }
      );

      // code for update button price: start
      if($(".SizeSwatchList input.SizeSwatch__Radio_one:checked").attr("data-price-without-money") && $(".SizeSwatchList input.SizeSwatch__Radio_one:checked").attr("data-price-without-money") !== "undefined"){

      var variantPrice = Number($(".SizeSwatchList input.SizeSwatch__Radio_one:checked").attr("data-price-without-money"));
      var inputValue = getInputValue();
      // console.log('one time packs input value', inputValue)
      var totalPrice = inputValue * variantPrice;
      var formatMoney = Shopify.formatMoney(totalPrice);
      let svg = `<svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM25.7071 8.7071C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928931C18.9526 0.538406 18.3195 0.538406 17.9289 0.928931C17.5384 1.31946 17.5384 1.95262 17.9289 2.34314L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.7071ZM1 9L25 9L25 7L1 7L1 9Z" fill="white"/>
</svg>
`;

      $(".ProductForm__AddToCart .wrap_text .update_price, .stay_ai_btn .wrap_text .update_price").text(formatMoney);

      $(".ProductForm__AddToCart, .stay_ai_btn").html(
        '<span class="wrap_text"><span>Add to cart</span> <div class="button-with-arrow"><span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +
          formatMoney +
          '</span>' + svg + '</div></span>'
      );

      let productPrice = $('.sub_sav_optioninner input[value="one time"]').attr('data-price');
      $(".ProductMeta__PriceList").html('<span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +productPrice +"</span>");

      $(
        ".ProductForm__QuantitySelector .QuantitySelector_numbers .plus_quantity"
      ).attr("data-variant-price", variantPrice);
      $(
        ".ProductForm__QuantitySelector .QuantitySelector_numbers .minus_quantity"
      ).attr("data-variant-price", variantPrice);  
    }
      //end 

      let activeID = $('.our-selling-product__tab-content .Product.tab-active').attr('id');
      if (activeID) {
        $(`#${activeID} .sub_sav_option_wrapper .delivery_option_wrapper`).hide();
        $(`#${activeID} .sub_sav_option_wrapper .main-price-with-text`).hide();
      } else {
        $('.sub_sav_option_wrapper .delivery_option_wrapper').hide();
        $('.sub_sav_option_wrapper .main-price-with-text').hide();
      }

      console.log('hiding delivery_option_wrapper 2A');
      $(".buy_more_save_wrapper").show();

      $(".buy_more_bundle .bundle_group input:checked").each(function (ie, em) {
        var get_available = $(em).attr("data-variant-available");
        var variant_price = $(em).attr("data-price");
        let variantPrice = Number($(this).attr("data-price-without-money"));
        let svg = `<svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM25.7071 8.7071C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928931C18.9526 0.538406 18.3195 0.538406 17.9289 0.928931C17.5384 1.31946 17.5384 1.95262 17.9289 2.34314L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.7071ZM1 9L25 9L25 7L1 7L1 9Z" fill="white"/>
</svg>
`;

        let formatMoney = Shopify.formatMoney(variantPrice);
        if (get_available == "true") {
          $(".ProductForm__AddToCart").removeAttr("disabled");
          $(".ProductForm__AddToCart").removeClass("Button--secondary");
          $(".ProductForm__AddToCart").addClass("Button--primary");
          $(".ProductForm__AddToCart, .stay_ai_btn").html(
            '<span class="wrap_text"><span>Add to cart</span> <div class="button-with-arrow"><span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +
              formatMoney +
              '</span>' + svg + '</div></span>'
          );
          let productPrice = $('.sub_sav_optioninner input[value="one time"]').attr('data-price');
          $(".ProductMeta__PriceList").html('<span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +productPrice +"</span>");
        } else {
          $(".ProductForm__AddToCart").prop("disabled", true);
          $(".ProductForm__AddToCart").removeClass("Button--primary");
          $(".ProductForm__AddToCart").addClass("Button--secondary");
          $(".ProductForm__AddToCart, .stay_ai_btn").text("Sold Out");
        }
      });

      // $(".yotpo-selling-plans .yotpo-radio-container").each(function (ie, ex) {
      //   var get_lable_text = $(ex)
      //     .find(
      //       ".yotpo-radio-button-text-wrapper .yotpo-radio-buttons label.yotpo-radio-label .yotpo-radio-label-text"
      //     )
      //     .text();

      //   if (get_lable_text == "One-time purchase") {
      //     $(".yotpo-selling-plans .yotpo-radio-buy-once-container .yotpo-radio-button-text-wrapper .yotpo-radio-buttons label.yotpo-radio-label input").attr("checked", true).trigger("click");
      //   }
      // });

      $(".buy_more_bundle .bundle_group input:checked").each(function (i, x) {
        //  var price_val = $(x).attr('data-price');
        let quantity = getInputValue();
        let variantPrice = Number($(this).attr("data-price-without-money"));
        let totalPrice = quantity * variantPrice;
        let formatMoney = Shopify.formatMoney(totalPrice);
        updatePrice(formatMoney);
        // $(
        //   ".premium_product.ProductForm__AddToCart .wrap_text .update_price"
        // ).text(formatMoney);
      });
    }
  }
);

$(document).on(
  "change",
  ".delivery_option_inner .option_group input",
  function () {
    //  var price_val = $(this).attr('data-price');
    //  $('.ProductForm__AddToCart .wrap_text .update_price').text(price_val);

    var get_lable_text = $(this).attr("data-val-id");
    console.log('Inside delivery_option_inner =>', get_lable_text)
    const sellingPlanInput = document.querySelector('.product__selling-plan-input')
    
    if (!sellingPlanInput || !get_lable_text) return

    sellingPlanInput.value = get_lable_text;

    let activeID =  $('.our-selling-product__tab-content .Product.tab-active').attr('id');

    if (activeID) {
      $(`#${activeID} .stay_ai_btn`).attr('data-selling-id', get_lable_text);
    } else {
      $('.stay_ai_btn').attr('data-selling-id', get_lable_text);
    }

    // $(
    //   ".yotpo-radio-container.yotpo-radio-subscription-container .yotpo-selling-plan-select-container .yotpo-select-wrapper .yotpo-frequency-options input"
    // ).each(function (ie, em) {
    //   var get_ss_text = $(em).val();
    //   $(em).attr("checked", false);

    //   if (get_lable_text == get_ss_text) {
    //     $(em).attr("checked", true).trigger("click");
    //   }
    // });
  }
);

$(document).ready(function () {
  $(".play-video").on("click", function (ev) {
    $(this).hide();
    $(".VideoWrapper iframe")[0].src += "?autoplay=1";
  });

  setTimeout(function () {
    // Set s&s % text
    var get_percentage = $(".delivery_option_inner .option_group input").attr("data-percentage");
    var getSavingPercentage = $(".delivery_option_inner .option_group input").attr('data-saving-percentage');
    // console.log('getSavingPercentage',getSavingPercentage);
    
    // console.log("is--" + get_percentage);
    

    if (window.location.pathname === '/collections/shop-now/products/piperwai-natural-deodorant-stick' || window.location.pathname === '/collections/shop-now/products/piperwai-natural-deodorant' || window.location.pathname === '/products/piperwai-natural-deodorant' || window.location.pathname === '/products/piperwai-natural-deodorant-stick') {
      var getPercentage = $(".delivery_option_inner .option_group input").last().attr("data-percentage");
      $(".sub_sav_optioninner .option_group input[value='Subscribe & Save']").next("label").text("Subscribe and Save Up to " + getSavingPercentage + "%");
    } else {

    if (!getSavingPercentage) {
      if (!get_percentage) {
        $(".sub_sav_optioninner .option_group input[value='Subscribe & Save']").next("label").text("Subscribe and Save Up to");
        console.log("is undefine");
      } else {
        $(".sub_sav_optioninner .option_group input[value='Subscribe & Save']").next("label").text("Subscribe and Save Up to " + get_percentage + "%");
        console.log("is not undefine");
      }
    } else {
      $(".sub_sav_optioninner .option_group input[value='Subscribe & Save']").next("label").text("Subscribe and Save Up to " + getSavingPercentage + "%");
    }
  }

    // $('.sub_sav_optioninner .option_group input:checked').each(function(ie,em){

    //   var check_text = $(em).val();
    //    if(check_text == 'Subscribe & Save'){
    //       $('.buy_more_save_wrapper').hide();
    //       $('.sub_sav_option_wrapper .delivery_option_wrapper').show();
    //       $('.delivery_option_inner .option_group input:checked').each(function(ix,en){
    //            var check_price = $(en).attr('data-price');
    //            $('.ProductForm__AddToCart .wrap_text .update_price').text(check_price);
    //        });
    //    }else{
    //       $('.buy_more_save_wrapper').show();
    //       $('.sub_sav_option_wrapper .delivery_option_wrapper').hide();
    //       $('.buy_more_bundle .bundle_group input:checked').each(function(ix,en){
    //            var check_price = $(en).attr('data-price');
    //            $('.ProductForm__AddToCart .wrap_text .update_price').text(check_price);
    //        });
    //    }
    // });

    // $('input[value="one time"]').prop("checked", true);

    if ($('.delivery_option_wrapper').css('display') !== 'none') {
      $('.sub_sav_optioninner input[value="Subscribe & Save"] + label').click();
    } else {
      $('.sub_sav_optioninner input[value="one time"] + label').click();
    }

    $(".buy_more_save_inner .buy_more_bundle .bundle_group input").each(
      function () {
        if ($(this).is(":checked")) {
          let quantity = getInputValue();
          let variantPrice = Number($(this).attr("data-price-without-money"));
          let totalPrice = quantity * variantPrice;
          let formatMoney = Shopify.formatMoney(totalPrice);
          updatePrice(formatMoney);
          // $(
          //   ".premium_product.ProductForm__AddToCart .wrap_text .update_price"
          // ).text(formatMoney);
        }
      }
    );
  }, 2500);
});

$(document).ready(function () {
  // Header Search
  $(".Search__Close").click(function () {
    $("#deskSearch_Input").val("");
    $(this).hide();
    $(".Search__InputIconWrapper").show();
    $("#deskSearch_Input").focus();
    $(".Search__Results").attr("aria-hidden", true);
    $(".Search__Results").css("display", "none");
  });

  $(".Header__Icon.Icon-search").click(function () {
    $(".Search__Close").show();
  });

  // announcement bar slider
  $(".AnnouncementBar__Wrapper").slick({
    draggable: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    fade: true,
    speed: 500,
    infinite: true,
    cssEase: "ease-in-out",
    touchThreshold: 100,
  });

  $(".AnnouncementBar__Wrapper").show();

  // logo slider smoothly
  $(".logoCarousel").slick({
    speed: 3000,
    autoplay: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    variableWidth: true,
  });

  // icon slider responsive on homepage
  $(".icon_Carousel").slick({
    dots: false,
    loop: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4.5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.6,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.5,
        },
      },
    ],
  });

  // review slider
  $(".ReviewsCarousel").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      '<button class="reviewPrev slick-prev"><img src="https://cdn.shopify.com/s/files/1/1075/6866/files/prev_arrow.png?v=1705404750"></button>',
    nextArrow:
      '<button class="reviewNext slick-next"><img src="https://cdn.shopify.com/s/files/1/1075/6866/files/next_arrow.png?v=1705404808"></button>',
    dots: false,
    loop: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
        },
      },
    ],
  });

  // video review slider
  $(".videoReview__Carousel").slick({
    infinite: false,
    // loop: false,
    dots: true,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 590,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  });

  // Review video play pause Start
  // $(".js-pw-reviews-media").click(function() {
  //   let $this = $(this);
  //   let videoPauseBtn = $this.find(".js-pw-reviews-media-btn-pause");
  //   let videoPlayBtn = $this.find(".js-pw-reviews-media-btn-play");
  //   let video = $this.find("video").get(0);

  //   if(video.paused) {
  //     $this.addClass("is-active");
  //     videoPlayBtn.hide();
  //     videoPauseBtn.show();
  //     video.play();
  //   }
  //   else {
  //     $this.removeClass("is-active");
  //     videoPlayBtn.show();
  //     videoPauseBtn.hide();
  //     video.pause();
  //   }
  // })
  // Review video play pause End

  $(".js-pw-reviews-media").click(function () {
    let $this = $(this);
    let videoPauseBtn = $this.find(".js-pw-reviews-media-btn-pause");
    let videoPlayBtn = $this.find(".js-pw-reviews-media-btn-play");
    let video = $this.find("video").get(0);

    // Pause all other videos
    $(".js-pw-reviews-media")
      .not($this)
      .each(function () {
        let otherVideo = $(this).find("video").get(0);
        let otherVideoPlayBtn = $(this).find(".js-pw-reviews-media-btn-play");
        let otherVideoPauseBtn = $(this).find(".js-pw-reviews-media-btn-pause");

        if (!otherVideo.paused) {
          $(this).removeClass("is-active");
          otherVideoPlayBtn.show();
          otherVideoPauseBtn.hide();
          otherVideo.pause();
        }
      });

    if (video.paused) {
      $this.addClass("is-active");
      videoPlayBtn.hide();
      videoPauseBtn.show();
      video.play();
    } else {
      $this.removeClass("is-active");
      videoPlayBtn.show();
      videoPauseBtn.hide();
      video.pause();
    }
  });

  // Collections slider resize start

  if ($(".js-pw-product-carousel-slider").length > 0) {
    setTimeout(function () {
      $(".js-pw-product-carousel-slider").flickity({
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        contain: true,
        cellAlign: "center",
        watchCSS: true,
        dragThreshold: 10,
        groupCells: true,
        arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 },
        draggable: false,
      });
    }, 1000);
  }

  // Collections slider resize End
});

// mega menu collection tabbing
function openTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

document.getElementById("defaultOpen").click();

// search desktop input
function logTextLength() {
  var inputValue = document.getElementById("deskSearch_Input").value;
  var textLength = inputValue.length;
  if (textLength == 0) {
    document.querySelector(".Search__InputIconWrapper").style.display = "block";
    document
      .querySelector(".Search__Results")
      .setAttribute("aria-hidden", true);
    document.querySelector(".Search__Results").style.display = "none";
    document.querySelector(".Search__Close").style.display = "none";
  } else {
    document
      .querySelector(".Search__Results")
      .setAttribute("aria-hidden", false);
    document.querySelector(".Search__Results").style.display = "block";
    document.querySelector(".Search__Close").style.display = "block";
    document.querySelector(".Search__InputIconWrapper").style.display = "none";
  }
}

// let closeButton = document.querySelector('.Search__Close');
// closeButton.addEventListener('click', function() {
//   document.querySelector('.Search__Results').setAttribute('aria-hidden', true);
//   document.getElementById('deskSearch_Input').value = '';
//   this.style.display = 'none';
//   document.querySelector('.Search__InputIconWrapper').style.display = 'block';
// });

// subscription widget
const productCTASelects = document.querySelectorAll(".productCTA select");

productCTASelects.forEach((select) => {
  select.addEventListener("change", function () {
    const selectedOption = select.options[select.selectedIndex];
    selectedOption.setAttribute("selected", "");

    // Log data-price for the selected option
    const dataPrice = selectedOption.getAttribute("data-price");
    // console.log("Selected data-price:", dataPrice);

    const priceList = select
      .closest(".ProductItem")
      .querySelector(".ProductItem__PriceList .ProductItem__Price");
    priceList.textContent = `${dataPrice}`;

    const atcButton = select
      .closest(".ProductItem")
      .querySelector(".collectionProductATC");
    const dataVariantId = selectedOption.getAttribute("data-variant-id");
    const ceckvariant = selectedOption.getAttribute("data-available");
    atcButton.setAttribute("data-atc-variant-id", dataVariantId);
    atcButton.setAttribute("data-available", ceckvariant);

    const SubscriptionId = selectedOption.getAttribute("data-val-id");
    // console.log(SubscriptionId)
    atcButton.setAttribute("data-atc-selling-id", SubscriptionId);
  });
});


setTimeout(() => {
  $('.productCTA select').each(function() {
    $(this).find('option:first').prop('selected', true);
  });
},1000);

$(document).on('click', '.collectionProductATC', function() {
  let selectedVariantId = Number($(this).attr("data-atc-variant-id"));
  let SellingId = Number($(this).attr("data-atc-selling-id")); 

  var check_status = $(this).attr('data-available');
  if(check_status !== 'Sold-Out'){
    if (SellingId) {
      ProductAddintoCart(selectedVariantId, SellingId);
    } else {
      ProductAddintoCartwithout_sellingplan(selectedVariantId);
    }
  }else{
    Swal.fire({
      text: 'Variant is Out-of-Stock',
      icon: 'error',
      confirmButtonText: 'ok',
      confirmButtonColor: '#00cfb4',
      iconColor: '#00cfb4'
    })
  }
})

function ProductAddintoCart(id, selling_id) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: id,
      selling_plan: selling_id,
    },
    dataType: "json",
    success: function (data) {
      console.log("product added successfully");
      // window.location.href = "/cart";
      document.addEventListener('rebuy:smartcart.show', (event) => {
        const smartcart = event.detail.smartcart;

        console.log('rebuy:smartcart.show: smartcart', smartcart);
      });
    },
    error: function () {
      console.log("Error", error);
    },
  });
}

function ProductAddintoCartwithout_sellingplan(selectedVariantId) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: selectedVariantId
    },
    dataType: "json",
    success: function (data) {
      console.log("product added successfully");
      // window.location.href = "/cart";
      document.addEventListener('rebuy:smartcart.show', (event) => {
        const smartcart = event.detail.smartcart;

        console.log('rebuy:smartcart.show: smartcart', smartcart);
      });
    },
    error: function () {
      console.log("Error", error);
    },
  });
}

// mobile header menu
// $(document).ready(function () {
//   $('.Collapsible__Button').on('click', function () {
//     var $button = $(this);
//     var $wrapper = $button.closest('.Collapsible.wraper_main');
//     var $allWrappers = $('.Collapsible.wraper_main');
//     var $backBtn = $('.wrapper_back_btn');

//     if ($button.attr('aria-expanded') === 'true') {
//       // If the button is expanded, hide other wrappers and the current one
//       $allWrappers.not($wrapper).hide();
//       $wrapper.hide();
//       console.log('nooooo falseeeeee');
//     } else {
//       // If the button is not expanded, hide the current wrapper
//       $allWrappers.not($wrapper).hide();
//       $wrapper.show();
//       $backBtn.show();
//       $button.hide();

//       $backBtn.click(function() {
//         $allWrappers.show();
//         $backBtn.hide();
//         $button.show();
//       });

//       console.log('yesssss trruuuue');
//     }
//   });
// });

$(document).ready(function () {
  $(document).on(
    "click",
    ".SidebarMenu__Nav .Collapsible__Button",
    function () {
      var $button = $(this);
      var $wrapper = $button.closest(".Collapsible.wraper_main");
      var $allWrappers = $(".Collapsible.wraper_main");
      var $backBtn = $(".wrapper_back_btn");
      var $drawerHeader = $(".Drawer__Header");

      setTimeout(function () {
        var isExpanded = $button.attr("aria-expanded") === "true";

        if (isExpanded) {
          $allWrappers.not($wrapper).hide();
          $wrapper.show();
          $backBtn.show();
          $button.hide();
          $wrapper.addClass("menuOpen");
          $drawerHeader.hide();
          console.log("yessss open");
        } else {
          console.log("noooo close");
          $allWrappers.not($wrapper).hide();
          $wrapper.hide();
          $drawerHeader.show();
          $wrapper.removeClass("menuOpen");
        }
      }, 0);
    }
  );

  $(".wrapper_back_btn").click(function () {
    $(".Collapsible.wraper_main").show();
    $(".wrapper_back_btn").hide();
    $(".Collapsible__Button").attr("aria-expanded", false);
    $(".Collapsible__Inner").css("height", "0");
    $(".Drawer__Header").show();
    $(".Collapsible.wraper_main").removeClass("menuOpen");
    $(".Collapsible__Button").show();
  });
});

// price change
$(document).on("click",".QuantitySelector_numbers .plus_quantity",function () {
    let quantity = Number($(this).closest(".ProductForm__QuantitySelector").find("#addCartQuantity").val());
    console.log('quantity when plus', quantity);
  
    let variantPrice = Number($(this).attr("data-variant-price"));
    let totalPrice = quantity * variantPrice;
    // console.log("quantity plus!");
    let formatMoney = Shopify.formatMoney(totalPrice);
    updatePrice(formatMoney);
    // $(".premium_product.ProductForm__AddToCart .wrap_text .update_price").text(
    //   formatMoney
    // );
  }
);

$(document).on("click",".QuantitySelector_numbers .minus_quantity",function () {
    // console.log("quantity minus!");
    let quantity = Number($(this).closest(".ProductForm__QuantitySelector").find("#addCartQuantity").val());
    console.log('quantity when minus', quantity);
    let variantPrice = Number($(this).attr("data-variant-price"));
    let totalPrice = quantity * variantPrice;
    let formatMoney = Shopify.formatMoney(totalPrice);
    updatePrice(formatMoney);
    // $(".premium_product.ProductForm__AddToCart .wrap_text .update_price").text(
    //   formatMoney
    // );
  }
);

// for delivery options subscription
function getSubscriptionPrice() {
  $(".delivery_option_inner .option_group input").each(function () {
    if ($(this).is(":checked")) {
      let quantity = getInputValue();
      let variantPrice = Number($(this).attr("data-variant-price"));
      let totalPrice = quantity * variantPrice;
      let formatMoney = Shopify.formatMoney(totalPrice);
      updatePrice(formatMoney);
      // $(
      //   ".premium_product.ProductForm__AddToCart .wrap_text .update_price"
      // ).text(formatMoney);

      $(
        ".ProductForm__QuantitySelector .QuantitySelector_numbers .plus_quantity"
      ).attr("data-variant-price", variantPrice);
      $(
        ".ProductForm__QuantitySelector .QuantitySelector_numbers .minus_quantity"
      ).attr("data-variant-price", variantPrice);
    }
  });
}

$(document).on(
  "change",
  ".ProductForm__QuantitySelector .QuantitySelector #addCartQuantity",
  function () {
    // console.log("quantity changed!");
    let quantity = Number($(this).val());
    let variantPrice = Number(
      $(this)
        .closest(".QuantitySelector")
        .find(".plus_quantity")
        .attr("data-variant-price")
    );
    let totalPrice = quantity * variantPrice;
    let formatMoney = Shopify.formatMoney(totalPrice);
    updatePrice(formatMoney);
    console.log('on change of addCartQuantity updaing price', formatMoney, quantity);
    // $(".premium_product.ProductForm__AddToCart .wrap_text .update_price").text(
    //   formatMoney
    // );
  }
);

// autoselect 2nd variant of PDP
$(document).ready(function () {

  let selected_variant = $(".buy_more_bundle .bundle_group input:checked").attr("data-pro-varid");
  if(typeof selected_variant !== "undefined") {
    $(".hidden_value_set + input").val(selected_variant);
  }

  //get cart count
 if($('.Header__CartDot').length > 0){ 
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      cache: false,
      dataType: 'json',
      success: function(cart) {
        // whatever you want to do with the cart obj
          // console.log(cart.item_count);
        $('.Header__CartDot span').html(cart.item_count);
      }
    });
 }

});


// on load button price changes
// if($('.SizeSwatchList').length > 0){
//   let priceSetInterval;  
//   let onloadSelecteFunc = function(){
//   let onloadSelected = $(".SizeSwatchList input:checked");
//   console.log("onloadSelected", onloadSelected);
//   let variantMainPrice = onloadSelected.attr("data-price-without-money");
//   console.log("variantMainPrice",variantMainPrice);
//   $(
//     ".ProductForm__QuantitySelector .QuantitySelector_numbers .plus_quantity"
//   ).attr("data-variant-price", variantMainPrice);
//   $(
//     ".ProductForm__QuantitySelector .QuantitySelector_numbers .minus_quantity"
//   ).attr("data-variant-price", variantMainPrice);
//   let inputValue = Number(
//     $(".ProductForm__QuantitySelector .QuantitySelector #addCartQuantity").val()
//   );
//   let totalPrice = inputValue * variantMainPrice;
//   let formatMoney = Shopify.formatMoney(totalPrice);
//   $(".ProductForm__AddToCart").html(
//     '<span class="wrap_text">Add to cart <span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +
//       formatMoney +
//       "</span></span>"
//   );
//   $(".ProductMeta__PriceList").html('<span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +
//       formatMoney +
//       "</span>");
//   }

//   priceSetInterval = setInterval(onloadSelecteFunc,500);
// setTimeout(function(){
// clearInterval(priceSetInterval);
// },1000); 
// }


function getInputValue() {
  let activeID = $('.our-selling-product__tab-content .Product.tab-active').attr('id');
  if (activeID) {
    return Number($(`#${activeID} .ProductForm__QuantitySelector .QuantitySelector #addCartQuantity`).val());
  }
  return Number($(".ProductForm__QuantitySelector .QuantitySelector #addCartQuantity").val());
}

function updatePrice(formatMoney) {
  let activeID = $('.our-selling-product__tab-content .Product.tab-active').attr('id');

  if (activeID) {
    $(`#${activeID} .ProductForm__AddToCart .wrap_text .update_price, #${activeID} .stay_ai_btn .wrap_text .update_price`).text(formatMoney);
    // console.log('tab section updating price');
  } else {
    $('.ProductForm__AddToCart .wrap_text .update_price, .stay_ai_btn .wrap_text .update_price').text(formatMoney);
    // console.log('tab section updating price else running');
  }
}



//on change of variant
$(document).on("change", ".SizeSwatch__Radio", function () {

  let intervalMainId;
  if($(".sub_sav_optioninner .option_group input:checked").val()=="Subscribe & Save"){
    // intervalMainId = setInterval(subscribeOnEvent,500);
  }
  // setTimeout(function(){
  //   clearInterval(intervalMainId);
  // },1000); 

  let t = $(this).val();
  let clickedVar = t.replace(" ", "_");
  $(".delivery_option_inner")
    .find(".variant-list")
    .each(function () {
      let selectedVar = $(this);
      if (selectedVar.hasClass(clickedVar)) {
        $(this).show();
        $(this).siblings().hide();
        // $(this).find('.option_group input[value="Every 1 month"]').trigger("click");
      }
    });
  let that = $(this);
  let variantMainPrice = that.attr("data-price-without-money");
  let variantID = Number(that.attr('data-variant-id'));
  $('.stay_ai_btn').attr('data-variant',variantID);

  $(
    ".ProductForm__QuantitySelector .QuantitySelector_numbers .plus_quantity"
  ).attr("data-variant-price", variantMainPrice);
  $(
    ".ProductForm__QuantitySelector .QuantitySelector_numbers .minus_quantity"
  ).attr("data-variant-price", variantMainPrice);
  
  let inputValue = getInputValue();
  // console.log('this is final dynamic inputValue', inputValue);

  let totalPrice = inputValue * variantMainPrice;
  let formatMoney = Shopify.formatMoney(totalPrice);
  let svg = `<svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM25.7071 8.7071C26.0976 8.31658 26.0976 7.68342 25.7071 7.29289L19.3431 0.928931C18.9526 0.538406 18.3195 0.538406 17.9289 0.928931C17.5384 1.31946 17.5384 1.95262 17.9289 2.34314L23.5858 8L17.9289 13.6569C17.5384 14.0474 17.5384 14.6805 17.9289 15.0711C18.3195 15.4616 18.9526 15.4616 19.3431 15.0711L25.7071 8.7071ZM1 9L25 9L25 7L1 7L1 9Z" fill="white"/>
</svg>
`;
  // $('.ProductForm__AddToCart .wrap_text .update_price').text(formatMoney);
  $(".ProductForm__AddToCart, .stay_ai_btn").html(
    '<span class="wrap_text"><span>Add to cart</span> <div class="button-with-arrow"><span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +
      formatMoney +
      '</span>' + svg + '</div></span>'
  );

  let productPrice = $('.sub_sav_optioninner input[value="one time"]').attr('data-price');
  $(".ProductMeta__PriceList").html('<span class="ProductMeta__Price update_price Price Text--subdued u-h4">' +productPrice +"</span>");

});


// 06-06-2024 subscription widget

//Stay AI commenting to test

let intervalId = setInterval(() => {
  $('.sub_sav_optioninner input[value="Subscribe & Save"]').attr('checked', 'checked').trigger('change');

  if ($('.yotpo-plans-and-policy-wrapper').length) {
    clearInterval(intervalId);
  }
  clearInterval(intervalId);
}, 1000);



function changeSubscription(currentValue) {
  const sellingPlanInput = document.querySelector('.delivery_option_wrapper [name="selling_plan"]')

  if (!sellingPlanInput) return 
  sellingPlanInput.setAttribute('value', currentValue)
}

//Select the frequency acording the variant 2 pack - 2 Month, etc

$(document).on('click', '.SizeSwatchList-subscribe li label', function() {
  //console.log('clicked index 300', $(this).closest('li').index());
  let inputID = $(this).attr('data-id');
  let inputValue = $(this).attr('data-value');
  //console.log('inputID',inputID, 'inputValue', inputValue);

  $('.delivery_option_inner .variant-list').hide();
  $(`.subcription-${inputValue}`).show();

  var selector = `#${inputID} + label`;
  let selectorID = $(selector).attr('data-val-id');
  let selectorVariantID = Number($(selector).attr('data-variant-id'));
  $('.stay_ai_btn').attr('data-variant',selectorVariantID);

  

  console.log(selector, selectorID, 'selectorID', typeof selectorID);
  setTimeout(function() {
    // console.log('selector clicked', );
    let selectedSellingID = Number($(selector).attr('data-val-id'));
    let activeID =  $('.our-selling-product__tab-content .Product.tab-active').attr('id');
    if (activeID) {
      $(`#${activeID} .stay_ai_btn`).attr('data-selling-id', selectedSellingID);
    } else {
      $('.stay_ai_btn').attr('data-selling-id', selectedSellingID);
    }

    $(selector).click();
    changeSubscription(selectorID);
  },100);
});

/*
$(document).ready(function() {
  setTimeout(() => {
    $('.sub_sav_optioninner input[type="radio"]:checked').each(function() {
      var checkedId = $(this).attr('id');

      if (checkedId === 'one_time') {
        console.log('1100 one time clicked');
        $('.sub_sav_optioninner input[value="one time"]').attr('checked', 'checked').trigger('change');
      } else {
        console.log('1100 subscribe clicked');
        $('.sub_sav_optioninner input[value="Subscribe & Save"]').attr('checked', 'checked').trigger('change');
      }
    });
  },1500);
});
*/


$(document).on('click', '.stay_ai_btn', function(e) {
  e.preventDefault();
  console.log('stay ai button clicked');
  let variantID = Number($(this).attr('data-variant'));
  let sellingID = Number($('.product__selling-plan-input').attr('value'));
  let quantity = getInputValue();

  if (sellingID) {
    addToCart(variantID, quantity, sellingID)
  } else {
    addToCart(variantID, quantity, null)
  }
});

function addToCart(id, qty, selling_id) {  
  $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  data: {
    quantity: qty,
    id: id,
    selling_plan: selling_id
  },
  dataType: 'json', 
  success: function (data) {
    console.log('added successfully');
    //window.open('/cart' , '_blank');
    // window.location.href = "/cart";
    document.addEventListener('rebuy:smartcart.show', (event) => {
      const smartcart = event.detail.smartcart;

      console.log('rebuy:smartcart.show: smartcart', smartcart);
    });
   }
  });
}


document.addEventListener('rebuy:cart.change', (event) => { 
  console.log('rebuy:cart.change event', event.detail); 
     $.getJSON('/cart.json', function (cart_data) {
          let cart_count = cart_data.item_count;
          console.log(cart_count);
         $('.Header__CartDot span').text(cart_count);   
    })
})


// bundle box slider js start
if ($(".js-bundle-product-carousel-slider").length > 0) {
  $(".js-bundle-product-carousel-slider").slick({
    autoplay: false,
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/1075/6866/files/prev_arrow.png?v=1705404750"></div>',
    nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/1075/6866/files/next_arrow.png?v=1705404808"></div>'
  });
}
// bundle box slider js end

// new add 08-10-2024

// announcementbar slider
if ($(".js-announcementbar-slider").length > 0) {
  var announcementbarSlider = {   
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: true,
  }

  var win = $(window);
  var slider = $(".js-announcementbar-slider");

  win.on("load resize", function () {  
    if (win.width() < 1140) {
      slider.not(".slick-initialized").slick(announcementbarSlider);
    } else if (slider.hasClass("slick-initialized")) {
      slider.slick("unslick");
    }
  });

}
// end announcementbar slider

//  you might like
if ($(".js-you-might-like-slider").length > 0) {
  $('.js-you-might-like-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 300,
    infinite: false,
    autoplaySpeed: 5000,
    autoplay: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
}
//  end you might like

// matchHeight
$('.you-might-like__slider-box .desc .heading').matchHeight({
  byRow: 0,
});
$('.our-selling-product__twoway-row .item .box figure').matchHeight({
  byRow: 0,
});
$('.our-selling-product__twoway-row .item .box h5').matchHeight({
  byRow: 0,
});
$('.our-selling-product__twoway-row .item .box p').matchHeight({
  byRow: 0,
});

// end matchHeight

//  main slider
if ($(".js-main-slider-wrapper").length > 0) {
  $('.js-main-slider-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: true,
    lazyLoad: 'ondemand',
    // appendDots: $('.js-main-slider-customdot'),
  });
}
//  end main slider

//  testimonial
if ($(".js-pw-testimonial-slider").length > 0) {
  $('.js-pw-testimonial-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: false,
    autoplaySpeed: 5000,
    autoplay: false,
    lazyLoad: 'ondemand',
    prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1256_5845)"><path d="M11.4199 0.387207L5.61347 6.19366L11.4199 12.0001" stroke="white"/></g><defs><filter id="filter0_d_1256_5845" x="0.90625" y="0.0336914" width="14.8672" height="20.3201" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1256_5845"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1256_5845" result="shape"/></filter></defs></svg></button>',
    nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_1256_5847)"><path d="M4.58008 12.6128L10.3865 6.80634L4.58008 0.99989" stroke="white"/></g><defs><filter id="filter0_d_1256_5847" x="0.226562" y="0.64624" width="14.8672" height="20.3201" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1256_5847"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1256_5847" result="shape"/></filter></defs></svg></button>',
  });
}
//  end testimonial

//  Ingredients You Can Trust
if ($(".js-ingredient-trust-slider").length > 0) {
  $('.js-ingredient-trust-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: false,
    autoplaySpeed: 5000,
    autoplay: true,
    lazyLoad: 'ondemand',
    prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" ><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"/></svg></button>',
    nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
}
//  end Ingredients You Can Trust

//  icon slider
if ($(".js-pw-icon-slider-inner").length > 0) {
  $('.js-pw-icon-slider-inner').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: false,
    autoplaySpeed: 5000,
    autoplay: false,
    lazyLoad: 'ondemand',
    prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" ><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"/></svg></button>',
    nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });
}
//  end icon slider

// radio check/uncheck
$(".our-selling-product__twoway-row .item .box").on("click", function () {
  $('.js-slider-for').slick('unslick');
  $('.js-slider-nav').slick('unslick');

  let getHrefData = $(this).attr("data-href");
  $(".our-selling-product__twoway-row .item .selling-product").prop("checked", false);
  $(".our-selling-product__tab-content .Product").removeClass("tab-active");
  $(this).siblings(".selling-product").prop("checked", true);
  $(".our-selling-product__tab-content #"+getHrefData).addClass("tab-active");
  initSliders();

});
// end radio check/uncheck

// our selling product
function initSliders() {
  if ($(".js-slider-for").length > 0) {
    $('.js-slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      dots: false,
      asNavFor: '.js-slider-nav'
    });
    $('.js-slider-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.js-slider-for',
      dots: false,
      arrows: true,
      focusOnSelect: true,
      prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.25 0.939941L0.999995 6.18995L6.25 11.44" stroke="#739997"/></svg></button>',
      nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 11.4448L6.00001 6.19482L0.750002 0.944813" stroke="#739997"/></svg></button>',
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3.5,
          }
        }
      ]
    });
  }
}
initSliders();
// end our selling product


// new homepage featured product add-to-cart start
$(document).on('click', '.js-featured-product-btn', function(e) {
  e.preventDefault();
  let variantID = Number($(this).attr('data-variant-id'));
  addToCart(variantID, 1, null);
});
// new homepage featured product add-to-cart end

// why piperwai list slider
var whyPiperwaiList = {                    
  dots: false,
  arrows: true,
  infinite: true,       
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="prev-arrow slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" ><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"/></svg></button>',
  nextArrow: '<button type="button" class="next-arrow slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"/></svg></button>',
}
$(window).on("load resize", () => {
  if ($(window).width() < 768) {
    $('.js-why-piperwai-list').not(".slick-initialized").slick(whyPiperwaiList);
  } else if ($('.js-why-piperwai-list').hasClass("slick-initialized")) {
    $('.js-why-piperwai-list').slick("unslick");
  }
});
// end why piperwai list slider

// homepage tab change js start
$(document).on('change', '.our-selling-product__twoway-row .item input', function() {
  if ($(this).is(':checked')) {
    let labelID = $(this).closest('.item').find('label[data-href]').attr('data-href');
    console.log('labelID', labelID);

    $(`#${labelID} .sub_sav_optioninner .option_group input`).each(function() {
      if ($(this).is(':checked')) {

        // on change subscription widget is selected to avoid confusion
        $(`#${labelID} input[value="Subscribe & Save"]`).click();
        $(`#${labelID} .SizeSwatchList-subscribe .HorizontalList__Item input[data-value="2_Pack"] + label[data-value="2_Pack"]`).click();

        $(`#${labelID} .delivery_option_wrapper`).show();
        $(`#${labelID} .SizeSwatchList-One-time`).hide();
        $(`#${labelID} .SizeSwatchList-subscribe`).show();

        // get current product subscription selling id
        let currentSellingID = $(`#${labelID} .product__selling-plan-input`).attr('value');
        console.log('currentSellingID', currentSellingID)


        $(`#${labelID} .product__selling-plan-input`).attr('value', currentSellingID);
        $(`#${labelID} .stay_ai_btn`).attr('data-selling-id', currentSellingID);
        
        
      }
    });
  }
});

// on load get subscription id
let onLoadactiveID =  $('.our-selling-product__tab-content .Product.tab-active').attr('id');
if (onLoadactiveID) {
  let onloadSellingPlan = $(`#${onLoadactiveID} .product__selling-plan-input`).attr('value');
  $(`#${onLoadactiveID} .stay_ai_btn`).attr('data-selling-id', onloadSellingPlan);


  let currentVariantID = Number($(`#${onLoadactiveID} .SizeSwatchList-subscribe .HorizontalList__Item input[data-value="2_Pack"]`).attr('data-variant-id'));
  setTimeout(function() {
    $(`#${onLoadactiveID} .stay_ai_btn`).attr('data-variant', currentVariantID);
  }, 1000)
  console.log(currentVariantID, 'currentVariantID')
}

// homepage tab change js end

/*$('.js-scroll-down-arrow').on('click', function() {
  const targetSection = $($(this).attr('href'));
  
  if (targetSection.length) {
      
      const offset = targetSection.offset().top - 200;

      $('html, body').animate({
          scrollTop: offset
      }, 200);
  }
});*/